/* A1 Keto landing v2 (17 Oct 2026) */
(function () {
  if (window.__v2) return; window.__v2 = 1;
  var END = Date.parse('2026-10-19T23:59:59-04:00');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = END - Date.now();
    if (left <= 0) {
      document.querySelectorAll('[data-v2gift]').forEach(function (el) { el.style.display = 'none'; });
      document.querySelectorAll('[data-v2after]').forEach(function (el) { el.style.display = ''; });
      return false;
    }
    var d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5), m = Math.floor(left % 36e5 / 6e4), s = Math.floor(left % 6e4 / 1e3);
    document.querySelectorAll('[data-v2cd]').forEach(function (el) {
      if (el.hasAttribute('data-short')) { el.textContent = (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's'; return; }
      el.innerHTML = '<span>' + d + 'd</span><span>' + pad(h) + 'h</span><span>' + pad(m) + 'm</span><span>' + pad(s) + 's</span>';
    });
    return true;
  }
  function init() {
  if (tick()) { var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000); }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .15 }) : null;
  document.querySelectorAll('.v2 [data-v2r], .v2c-good .v2c-row').forEach(function (el, i) {
    if (el.classList.contains('v2c-row')) el.querySelector('.ic').style.transitionDelay = (i % 7) * 110 + 'ms';
    io ? io.observe(el) : el.classList.add('in');
  });
  document.querySelectorAll('[data-v2moments]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    var chips = root.querySelectorAll('.v2m-chip'), ans = root.querySelector('.v2m-ans');
    function show(i) {
      chips.forEach(function (c, j) { c.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      var d = data[i];
      ans.innerHTML = '<div class="q">' + d.q + '</div><div class="a"><div class="l">What the book gives you</div><div class="t">' + d.t + '</div><div class="s">' + d.s + '</div>' + (d.gift && Date.now() < END ? '<span class="gift">Your gift this weekend</span>' : '') + '</div>';
      ans.classList.remove('swap'); void ans.offsetWidth; ans.classList.add('swap');
    }
    chips.forEach(function (c, i) { c.addEventListener('click', function () { show(i); }); });
    show(0);
  });
  document.querySelectorAll('[data-v2moods]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    var mood = 0, meal = 0;
    var tabs = root.querySelectorAll('.v2mo-tab'), meals = root.querySelectorAll('.v2mo-meal');
    var el = function (s) { return root.querySelector(s); };
    function render(first) {
      var m = data[mood], r = m.r[meal];
      tabs.forEach(function (t, i) { t.setAttribute('aria-selected', i === mood ? 'true' : 'false'); });
      meals.forEach(function (t, i) { t.setAttribute('aria-selected', i === meal ? 'true' : 'false'); });
      el('.ch').textContent = 'Chapter 0' + (mood + 1) + ' · ' + m.name;
      el('h3').textContent = m.title; el('.p').textContent = m.text; el('.rl').textContent = m.rule;
      var img = el('.v2mo-rec img');
      if (first) { img.src = r.img; img.alt = r.name; } else { img.style.opacity = 0; setTimeout(function () { img.src = r.img; img.alt = r.name; img.style.opacity = 1; }, 180); }
      el('.no').textContent = '№ ' + r.n + ' · ' + m.name + ' · ' + ['Breakfast', 'Lunch', 'Dinner'][meal];
      el('.nm').textContent = r.name; el('.pw').textContent = 'Perfect when… ' + r.pw;
      el('.st').innerHTML = r.st.map(function (x) { return '<span>' + x + '</span>'; }).join('');
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { mood = i; render(); }); });
    meals.forEach(function (t, i) { t.addEventListener('click', function () { meal = i; render(); }); });
    render(true);
  });
  var st = document.querySelector('.v2sticky');
  if (st) {
    var fin = document.querySelector('#v2-gift');
    window.addEventListener('scroll', function () {
      var show = window.scrollY > 700;
      if (fin) { var r = fin.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) show = false; }
      st.classList.toggle('on', show);
    }, { passive: true });
  }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
